import styled from 'styled-components';
import { Link } from 'react-scroll';
import { ContainerMarginSections, Colors, fonts } from '../style/GlobalStyles';

const Stage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;
`;

const Circles = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: -52px;
  }

  @media (max-width: 520px) {
    flex-direction: column;
    & > * + * {
      margin-left: 0;
      margin-top: -52px;
    }
  }
`;

const FilledCircle = styled.div`
  width: 270px;
  height: 270px;
  border-radius: 50%;
  background: ${Colors.ink};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 2;

  span {
    font-family: ${fonts.script};
    color: ${Colors.lime};
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.1;
  }

  @media (max-width: 520px) {
    width: 220px;
    height: 220px;
  }
`;

const OutlineCircle = styled.div`
  width: 270px;
  height: 270px;
  border-radius: 50%;
  border: 1.5px solid ${Colors.ink};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;

  a {
    font-family: ${fonts.body};
    font-weight: 600;
    font-size: 1.05rem;
    color: ${Colors.ink};
    text-decoration: underline;
    text-underline-offset: 5px;
    cursor: pointer;
  }

  &:hover {
    background: ${Colors.lime};
  }

  @media (max-width: 520px) {
    width: 220px;
    height: 220px;
  }
`;

const ConsultCTA = () => {
  return (
    <ContainerMarginSections>
      <Stage className="gsap-fade-up">
        <Circles>
          <FilledCircle>
            <span>
              Fancy a<br />
              chat?
            </span>
          </FilledCircle>
          <OutlineCircle>
            <Link to="contact" smooth spy>
              Let's talk →
            </Link>
          </OutlineCircle>
        </Circles>
      </Stage>
    </ContainerMarginSections>
  );
};

export default ConsultCTA;
